<template>
  <div class="auth-wrapper">
    <div class="auth-header__menu main-clear">
      <router-link  :to="{name:'Login'}" class="prev-page" title="Назад"></router-link>
    </div>
    <div class="auth-content">
      <div class="auth-area">
        <Logo/>
        <SmsCode/>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
    import SmsCode from '@/components/auth/SmsCode.vue'
    import Logo from '@/views/auth/Logo.vue'
    import Footer from "@/views/auth/Footer";

    export default {
        name: 'Auth',
        components: {
            Footer,
            Logo,
            SmsCode
        }
    }
</script>
